import React from 'react';
import { Helmet } from 'react-helmet-async';
interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
}
export function SEO({
  title,
  description,
  canonical
}: SEOProps) {
  const siteTitle = 'Khyber Medical Association UK';
  const fullTitle = `${title} | ${siteTitle}`;
  return <Helmet data-id="element-110">
      <title data-id="element-111">{fullTitle}</title>
      <meta name="description" content={description} data-id="element-112" />
      <meta property="og:title" content={fullTitle} data-id="element-113" />
      <meta property="og:description" content={description} data-id="element-114" />
      <meta property="og:type" content="website" data-id="element-115" />
      <meta name="twitter:card" content="summary_large_image" data-id="element-116" />
      <meta name="twitter:title" content={fullTitle} data-id="element-117" />
      <meta name="twitter:description" content={description} data-id="element-118" />
      {canonical && <link rel="canonical" href={canonical} data-id="element-119" />}
    </Helmet>;
}